import { ActivityWhatsapp } from "../../../components/ActivityWhatsappDisplay";
import { ActivityPluginProps } from "../../registry/ActivityPluginTypes";

export const ActivityWhatsappCard = ({ data, reload }: ActivityPluginProps) => {
  return <ActivityWhatsapp data={data} reload={() => reload()} />;
};
